window.backgroundService = {
  get() {
    return axios.get(`/api/background/get.php`);
  },

  save(data) {
    return axios.post('/api/background/save.php', data);
  },

  upload(backgroundId, file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', backgroundId);
    return axios.post('/api/background/upload.php', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  delete(id) {
    return axios.post('/api/background/delete.php', { id });
  }
};
